import styles from './loader.module.scss';

export interface LoaderProps {
  size: number
}

export function Loader(props: LoaderProps) {
  const { size } = props;
  return <div style={{width: size,height:size}} className={styles['loader']}></div>;
}
